import React, { useState, useEffect } from 'react';

const API = 'http://111.88.156.8:8000/api/v1';

function S1Invoices() {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    fetch(API + '/s1/invoices')
      .then(r => r.json())
      .then(d => setInvoices(d.invoices || []));
  }, []);

  return (
    <div>
      <h2>1C: Invoices</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        {invoices.length > 0 ? 'Demo mode — connect real 1C in Settings' : 'Loading...'}
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Number</th>
            <th style={{ padding: 8 }}>Date</th>
            <th style={{ padding: 8 }}>Counterparty</th>
            <th style={{ padding: 8, textAlign: 'right' }}>Amount</th>
            <th style={{ padding: 8 }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((inv, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{inv.number}</td>
              <td style={{ padding: 8 }}>{inv.date}</td>
              <td style={{ padding: 8 }}>{inv.counterparty}</td>
              <td style={{ padding: 8, textAlign: 'right' }}>{inv.amount.toLocaleString()} ₽</td>
              <td style={{ padding: 8, color: inv.status === 'paid' ? '#10B981' : '#F59E0B' }}>
                {inv.status === 'paid' ? '● Paid' : '○ Unpaid'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default S1Invoices;